
import IconifyIcon from "@iconify/vue";

import roundPlayArrowIconData from '@iconify-icons/ic/round-play-arrow';
import roundPauseIconData from '@iconify-icons/ic/round-pause';
import roundStopIconData from '@iconify-icons/ic/round-stop';
import roundSyncIconData from '@iconify-icons/ic/round-sync';
import baselineArrowCircleDownIconData from '@iconify-icons/ic/baseline-arrow-circle-down';
import baselineAccessTimeIconData from '@iconify-icons/ic/baseline-access-time';
import outlineRotateLeftIconData from '@iconify-icons/ic/outline-rotate-left';
import roundVolumeUpIconData from '@iconify-icons/ic/round-volume-up';
import roundVolumeDownIconData from '@iconify-icons/ic/round-volume-down';
import roundVolumeMuteIconData from '@iconify-icons/ic/round-volume-mute';
import baselineRemoveRedEye from '@iconify-icons/ic/baseline-remove-red-eye';
import metronomeIconData from '@iconify-icons/mdi/metronome';
import metronomeTickIconData from '@iconify-icons/mdi/metronome-tick';
import outlineAudiotrackIconData from '@iconify-icons/ic/outline-audiotrack';
import roundKeyboardArrowUpIconData from '@iconify-icons/ic/round-keyboard-arrow-up';
import roundKeyboardArrowDownIconData from '@iconify-icons/ic/round-keyboard-arrow-down';

IconifyIcon.addIcon('play', roundPlayArrowIconData);
IconifyIcon.addIcon('pause', roundPauseIconData);
IconifyIcon.addIcon('stop', roundStopIconData);
IconifyIcon.addIcon('loop', roundSyncIconData);
IconifyIcon.addIcon('autoscroll', baselineArrowCircleDownIconData);
IconifyIcon.addIcon('countin', baselineAccessTimeIconData);
IconifyIcon.addIcon('reset', outlineRotateLeftIconData);
IconifyIcon.addIcon('volume-high', roundVolumeUpIconData);
IconifyIcon.addIcon('volume-low', roundVolumeDownIconData);
IconifyIcon.addIcon('volume-off', roundVolumeMuteIconData);
IconifyIcon.addIcon('eye', baselineRemoveRedEye);
IconifyIcon.addIcon('metronome-off', metronomeTickIconData);
IconifyIcon.addIcon('metronome-on', metronomeIconData);
IconifyIcon.addIcon('note', outlineAudiotrackIconData);
IconifyIcon.addIcon('arrow-up', roundKeyboardArrowUpIconData);
IconifyIcon.addIcon('arrow-down', roundKeyboardArrowDownIconData);

Vue.component('IconifyIcon', IconifyIcon);
